import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./styles.css";

function LocationCard({ loc, dispatch }) {
  return (
    <Card border="info" className="loc-card" style={{ minWidth: "15rem" }}>
      <Card.Body>
        <Card.Title className="text-center">
          <Card.Link as={Link} to={`/location/${loc.split(" ").join('_')}`}>
            {loc}
          </Card.Link>
        </Card.Title>
      </Card.Body>
    </Card>
  );
}

export default LocationCard;
